import './style.scss';
import { Timer } from '../../../js/components/Timer/Timer';
import { saleEndDate } from '../../../js/components/SaleEndDate/SaleEndDate'
import { translate } from '../../../js/utils/translations';
import { createElement, render, RenderPosition } from '../../../js/utils/render';
import { showAutopaymentModal } from '../../popups/v1/AutopayModalNew/scripts'
import { showUpSaleModal } from '../../popups/v1/UpSaleModal/scripts'

export default !function () {
  const block = document.querySelector('.price-v9');

  if (!block) {
    return;
  }

  const autopaymentTypes = block.querySelector('.price-v9__types');
  const form = block.querySelector('.form');

  const ButtonText = {
    consultation: translate('form.button.consultation'),
    cloudpayments: translate('form.button.cloudpayments'),
    credit: translate('form.button.credit')
  };

  // analytics
  form && form.addEventListener('form-sended', (evt) => {
    const { formData } = evt.sendingResult;
    const requestId = formData.get('request_id');

    window.$analytics && window.$analytics.push('price-form-send', {
      requestId
    });

    if (autopaymentTypes) {
      const chosenType = autopaymentTypes.querySelector('input:checked');
      const action = chosenType.dataset.analytics;

      window.$analytics && window.$analytics.push('price-type-form-send', { action });
    }
  });

  // init timer
  const timerWrapper = block.querySelector('.price-v9__timer-block')

  if (timerWrapper) {
    saleEndDate
      .addObserver(time => new Timer({ time, timerWrapper }))
  }

  const buttonText = block.querySelector('.price-v9__button .ui-button__text');

  if (autopaymentTypes) {
    const pushAutopaymentAnalytics = (target) => {
      let action = target.dataset.analytics;

      if (action.includes('_')) {
        action = action.replace('_', ' ');
      }

      window.$analytics && window.$analytics.push('price-type-click', {
        action: `Select ${action}`
      });
    };

    autopaymentTypes.addEventListener('change', (evt) => {
      const chosenType = evt.target.value;

      buttonText.textContent = ButtonText[chosenType]
        ? ButtonText[chosenType]
        : ButtonText.credit;

      pushAutopaymentAnalytics(evt.target);
    });
  }

  /* b2b */
  const b2b = block.querySelector('.ui-checkbox-field__input');

  if (b2b) {
    const companyInput = block.querySelector('[data-field="b2b"]');
    const companyField = companyInput.closest('.form__input--hidden');

    setTimeout(() => {
      if (b2b.checked) {
        companyField.classList.add('form__input--show');
      }
    }, 100)

    b2b.addEventListener('change', () => {
      companyField.classList.toggle('form__input--show');
      companyInput.disabled = !b2b.checked;
    });
  }
  /* end b2b */

  // TODO: Удалить после ABC тест автооплаты
  const getABCTemplate = () => {
    return (
      `<div class="price-types">
        <div class="price-types__method ui-autopayment-method">
          <label class="ui-autopayment-method__label">
            <input
              name="submit_type"
              value="consult"
              type="radio"
              checked
              class="ui-autopayment-method__input sr-only"
            >

            <span class="ui-autopayment-method__box">
              <span class="ui-autopayment-method__title f f--16 f--m">
                Записаться на&nbsp;бесплатную консультацию
              </span>
            </span>
          </label>
        </div>

        <div class="price-types__method ui-autopayment-method">
          <label class="ui-autopayment-method__label">
            <input
              name="submit_type"
              value="pay"
              type="radio"
              class="ui-autopayment-method__input sr-only"
            >

            <span class="ui-autopayment-method__box">
              <span class="ui-autopayment-method__title f f--16 f--m">
                Оплатить и&nbsp;получить дополнительную скидку
              </span>

              <span
                data-admin-theme="black"
                class="ui-tag ui-tag--small ui-tag--bg"
                style="--tag-bg-color: var(--accent-sale-color); --tag-text-color: var(--accent-always-black-color);"
              >
                Выгодно
              </span>
            </span>
          </label>
        </div>
      </div>`
    )
  };

  const changeFormView = (group) => {
    const twoStep = block.querySelector('.price-v9__step:nth-child(2)');

    if (!twoStep) {
      return;
    }

    const title = twoStep.querySelector('.price-v9__subtitle');
    const oneStep = block.querySelector('.price-v9__step');
    const submitTextButton = block.querySelector('.price-v9__button .ui-button__text');

    form.action = '/api/landgen/send/';
    form.dataset.formType = 'lead';
    oneStep.remove();
    title.innerHTML = 'Записаться на&nbsp;консультацию или оплатить на&nbsp;сайте';
    title.classList = 'price-v9__subtitle price-v9__subtitle--no-payments h h--4';
    submitTextButton.textContent = 'Отправить';

    if (group === 'C') {
      form.removeAttribute('data-redirect-type');
      form.dataset.formType = 'consult';
      submitTextButton.textContent = 'Записаться';

      const typesElement = createElement(getABCTemplate());
      const wrapper = form.querySelector('.price-v9__contacts');

      typesElement.addEventListener('change', (evt) => {
        const type = evt.target.value

        submitTextButton.textContent = type === 'pay' ? 'Оплатить' : 'Записаться';
        window.$analytics?.push('price-form-type-change', { label: type });
      })

      form.addEventListener('form-success', (evt) => {
        const type = evt.sendingResult?.formData?.get('submit_type')
        const upSaleTemplate = document.querySelector('#up-sale-form')
          ?.content.cloneNode(true).querySelector('.up-sale-form')
        const autopaymentModalTemplate = document.querySelector('#auto-payment-form')
          ?.content.cloneNode(true).querySelector('.auto-payment-form')

        window.$analytics?.push('price-form-type-submit', { label: type })

        if (upSaleTemplate) {
          showUpSaleModal(upSaleTemplate, {
            submitHandler: (nomenclatureId) => showAutopaymentModal(autopaymentModalTemplate, { nomenclatureId }),
            type,
            blockName: block.dataset.blockName ?? 'Блок без названия'
          })

          return
        }

        showAutopaymentModal(autopaymentModalTemplate, {
          nomenclatureId: landingInfo.nomenclature_ID, // eslint-disable-line
          type
        });
      });

      render(wrapper, typesElement, RenderPosition.BEFOREBEGIN);
    }
  };

  window.paymentAbTestPromise?.finally(() => {
    if (window.paymentAbTestGroup && window.paymentAbTestGroup !== 'A') {
      changeFormView(window.paymentAbTestGroup);
    }
  })
}();
